import { SubscriptionServicePromiseClient } from '@jotta/grpc-web/no/jotta/openapi/subscription/payment.v2_grpc_web_pb'
import type {
  ApplyVoucherResponse,
  DescribeVoucherResponse,
  GetPaymentInfoResponse,
  ListOrdersResponse,
} from '@jotta/grpc-web/no/jotta/openapi/subscription/payment.v2_pb'
import {
  ApplyVoucherRequest,
  DescribeVoucherRequest,
  GetPaymentInfoRequest,
  ListOrdersRequest,
} from '@jotta/grpc-web/no/jotta/openapi/subscription/payment.v2_pb'
import { env } from '@jotta/utils/env'

import { withGrpcClientMiddleware } from './grpcutils'

export {
  Currency,
  GetPaymentInfoResponse,
  Order,
  SubscriptionInterval,
} from '@jotta/grpc-web/no/jotta/openapi/subscription/payment.v2_pb'

let subscriptionClient: SubscriptionServicePromiseClient

const GRPC_WEB_API = env.grpcApi

export function getSubscriptionClient() {
  if (!subscriptionClient) {
    subscriptionClient = withGrpcClientMiddleware(
      'subscription',
      new SubscriptionServicePromiseClient(GRPC_WEB_API),
    )
  }

  return subscriptionClient
}

export const getSubscriptionDetails = (): Promise<GetPaymentInfoResponse> => {
  const request = new GetPaymentInfoRequest()
  return getSubscriptionClient().getPaymentInfo(request)
}

export async function getBillingHistory(): Promise<ListOrdersResponse> {
  return await getSubscriptionClient().listOrders(new ListOrdersRequest())
}

export async function describeVoucher(
  code: string,
): Promise<DescribeVoucherResponse.AsObject> {
  const request = new DescribeVoucherRequest()
  request.setCode(code)
  const response = await getSubscriptionClient().describeVoucher(request)
  return response.toObject()
}

export async function applyVoucher(
  code: string,
): Promise<ApplyVoucherResponse.AsObject> {
  const request = new ApplyVoucherRequest()
  request.setCode(code)
  const response = await getSubscriptionClient().applyVoucher(request)
  return response.toObject()
}
